import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import { DragSource, DropTarget } from 'react-dnd';
import flow from 'lodash/flow';
import { Resizable, ResizableBox } from 'react-resizable';
import Chip from '@material-ui/core/Chip';
import classNames from 'classnames';
import { Card as MatCard, Button, CardContent, Typography, Tooltip, Icon, IconButton } from '@material-ui/core';

import SnackbarContent from '@material-ui/core/SnackbarContent';

function collectSource(connect, monitor) {
    return {
        connectDragSource: connect.dragSource(),
        isDragging: monitor.isDragging()
    };
}


class Card extends Component {
    handleClick = () => {
    }

    render() {
        const { classes, card, isDragging, connectDragSource, connectDropTarget, themeForTextColor } = this.props;
        const opacity = isDragging ? 0 : 1;

        if (card.alreadySelected) {
            return (
                <div style={{ width: '100%', opacity }}>
                    <Card
                        style={{
                            borderRadius: 4,
                            borderWidth: 2,
                            borderColor: card.Color,
                        }}
                    >
                        <CardContent
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                alignContent: 'center',
                                padding: '8px'
                            }}
                        >
                            <Typography>{card.title}</Typography>
                            <IconButton onClick={() => this.props.removeEventFromCalendar(card)} color="inherit" style={{ padding: '0' }}>
                                <Icon>delete</Icon>
                            </IconButton>
                        </CardContent>
                    </Card>
                </div>
            )
        }

        return connectDragSource(connectDropTarget(
            <div style={{ width: '100%', opacity }}>
                    <MatCard
                        style={{
                            borderRadius: 4,
                            borderWidth: 2,
                            borderColor: card.Color,
                        }}
                    >
                        <CardContent
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                alignContent: 'center',
                                padding: '8px'
                            }}
                        >
                            <Typography>{card.title}</Typography>
                            <Tooltip title={card.desc || ''}>
                                <Icon>info</Icon>
                            </Tooltip>
                        </CardContent>
                    </MatCard>
            </div>
        ));
    }
}
const cardSource = {

    beginDrag(props) {
        return Object.assign({},
            {
                event: props.card,
                index: props.index,
                listId: props.listId,
                card: props.card

            },

            { anchor: 'drop' }
        )
    },

    endDrag(props, monitor) {
        // console.log(props, monitor)
        const item = monitor.getItem();
        const dropResult = monitor.getDropResult();
        if (!dropResult) {
            return null
        }
        if (dropResult && dropResult.listId !== item.listId) {
            props.removeCard(props.card.assignment_id, props.listId);
        }
    }
};

const cardTarget = {

    hover(props, monitor, component) {
        const dragIndex = monitor.getItem().index;
        const hoverIndex = props.index;
        const sourceListId = monitor.getItem().listId;

        // Don't replace items with themselves
        if (dragIndex === hoverIndex) {
            return;
        }

        // Determine rectangle on screen
        const hoverBoundingRect = findDOMNode(component).getBoundingClientRect();

        // Get vertical middle
        const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

        // Determine mouse position
        const clientOffset = monitor.getClientOffset();

        // Get pixels to the top
        const hoverClientY = clientOffset.y - hoverBoundingRect.top;

        // Only perform the move when the mouse has crossed half of the items height
        // When dragging downwards, only move when the cursor is below 50%
        // When dragging upwards, only move when the cursor is above 50%

        // Dragging downwards
        if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
            return;
        }

        // Dragging upwards
        if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
            return;
        }

        // Time to actually perform the action
        if (props.listId === sourceListId) {
            props.moveCard(dragIndex, hoverIndex, monitor.getItem().card);
            // props.prepareDisplayOrders()
            // Note: we're mutating the monitor item here!
            // Generally it's better to avoid mutations,
            // but it's good here for the sake of performance
            // to avoid expensive index searches.
            monitor.getItem().index = hoverIndex;
        }
    }
};

export default flow(
    DropTarget("event", cardTarget, connect => ({
        connectDropTarget: connect.dropTarget()
    })),
    // DragSource("event", cardSource, (connect, monitor) => ({
    //     connectDragSource: connect.dragSource(),
    //     isDragging: monitor.isDragging()
    // }))
    DragSource("event", cardSource, collectSource)
)(Card);



// WEBPACK FOOTER //
// src/main/content/lesson/ScheduleComponents/EventCard.js